import * as angular from 'angular'
import { SearchResource } from './search-resource.service'

/**
 * Resource for querying the search API.
 */
angular
  .module('webregister.components')
  .service('searchResource', SearchResource)
